import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import { ActiveBadge, PromoInfoView } from "compid/shared/views/PromoView/components/views/PromoInfoView";
import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import UIButton from "compid/ui/UIButton";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function BillerDetailsReminderUpsell
 * @param {Boolean} hasReminder - allows us to set if reminder is active
 * @return {React.Component}
 * @exported true
 * @description The Reminder that shows in the BillerDetailsPage
 */

export default function BillerDetailsReminderUpsell(props){ 
  const reminder = props.reminder;
  const hasReminder = reminder ?? false;
  const onSubmit = props.onSubmit ?? undefined;
  const frequency = hasReminder ? reminder.billReceivedFrequency : undefined;
  const days = hasReminder ? reminder.daysToRemindMeInAdvanced : undefined;
  const amount = hasReminder ? reminder.amount.format() : undefined;
  const id = hasReminder ? reminder.id : undefined;

  return(
    <div className="biller-details-reminder-upsell  biller-details-upsell-view">
      <WidgetView>
        <WidgetMainContentView>

          {/* Inactive */}
          { !hasReminder && 
          <PromoInfoView 
              icon={ <SVGAsset id="BellIcon" className="upsell-icon" /> } 
              title="Reminders" 
              description={ !hasReminder &&  "Let us remind you when your bill is due."}
              dataPoint="Biller_Details_Let_Us_Remind_You" 
              >
          </PromoInfoView> }

          {/* Active */}
          {hasReminder && 
          <PromoInfoView 
              icon={ <SVGAsset id="BellIcon" className="upsell-icon" /> } 
              title="Reminders" 
              description= {<BillerDetailsRemindersDescription id={ id } frequency={frequency} days={days} amount={amount} />}
              activeBadge={<ActiveBadge />}
              dataPoint="Biller_Details_Reminders" 
              >
          </PromoInfoView> }

          { !hasReminder && 
            <ButtonContainer>
                <UIButton className="secondary-button" onClick={ onSubmit } dataPoint="Biller_Details_Add_Reminder">Add reminders</UIButton>
            </ButtonContainer> }

        </WidgetMainContentView>
      </WidgetView>
    </div>
  );
}

/**
 * @function BillerDetailsRemindersDescription
 * @param {String} days - allows us to set days before the reminder
 * @param {String} amountDue - allows us to set the amount of the reminder
 * @return {React.Component}
 * @exported false
 * @description The description that shows in the BillerDetailsReminderUpsell with reminders are active.
 * @example
 * <BillerDetailsReminderDescription days="03" amountDue="$100.00" />
 */

function BillerDetailsRemindersDescription(props){
  const frequency = props.frequency ?? "[frequency]";
  const days = props.days ?? "[days]";
  const amount = props.amount ?? "[amountDue]";
  const id = props.id ?? "undefined";

  return(
    <div className="biller-details-reminder-description flex-container flex-horizontal align-center">
      <p className="flex-width">Your reminder will appear { frequency } { days } days before the { amount } is due.</p>
      <DisabledPrompt>
        <Link>
          <div className="flex-container flex-horizontal align-center">
            <SVGAsset id="EditIcon" className="blue-icon left-icon set-width" />
            <p className="blue-text" data-point={ `Biller_Details_Reminders_Edit_${ id }` }>Edit</p>
          </div>
        </Link>
      </DisabledPrompt>
    </div>
  );
}